import tw from "twin.macro";
import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { useCartContext } from "context/UseCartContext";
import { motion } from "framer-motion";
import TechWalletimg from "../images/TechWallet/TechWalletimg.png";
import { getCcavenuePaymentLinkData } from "api/AppConfigApi";
import { getBranchId, getCustomerId, getOrderKeyId, setOrderKeyId, setTwalletInvsId } from "utility/HeaderConfig";
import { PurityApi } from "api/PurityApi";
import { getChitBenefitValueData, getCustomerSchemeById, schemeDetails, schemeStatus, schemeType } from "api/NewSchemeApi";
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  currentDateToUtcDate,
  currentRegister,
  DIGIGOLD,
  filterFormatFromDate,
  filterFormatToDate,
  FIVEHUNDRED,
  HUNDRED,
  // MINIMUM_WET_STR,
  numberCutOff,
  ONE_GRAM,
  PLUS_SYMBOL,
  THOUSAND,
  TW0THOUSAND,
  TWO_GRAM,
  weightDecimalPlaces,
  ZERO_POINT_FIVE,
} from "utility/Constant";
import { getCustomer } from "api/CustomerApi";
import { getPageOrderStatus, paygOrderStatus, paygOrderStatusUpdate } from "api/OnlinePaymentApi";
import moment from "moment";
import { getAllPaymentMode } from "api/CheckOutApi";
import { useVisibilityChange } from "hooks/useVisibilityChange";

const Container = tw.div`relative overflow-hidden`;

function TechWallet({ configImages ,branch }) {

  const location = useLocation();
  const parm = location.state;
  const documentVisibility = useVisibilityChange();
  const [banner, setBanner] = useState([]);
  const [Amount, setAmount] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [maxDuevalue, setMaxDuevalue] = useState([]);//eslint-disable-line
  const [recentGoldRate, setRecentGoldRate] = useState({
    metaProdTypeName: "Gold",
    rate: "N/A",
    unitType: "",
  });
  const [weight, setWeight] = useState("");
  const [benefitValue, setBenefitValue] = useState(0);//eslint-disable-line
  const [payableValue, setPayableValue] = useState(0);//eslint-disable-line
  const [prpsData, setPrpsData] = useState(parm);//eslint-disable-line
  const [changeRadioButton, setChangeRadioButton] = useState("Buyinrupee");
  const [shemeMeta,setShemeMeta] = useState([]);
  const [Details, setDetails] = useState({});
  const [Scheme, setScheme] = useState([]);//eslint-disable-line
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [payLoading, setPayLoading] = useState(false);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [chitId,setChitId] =useState([]);
  const [paygResponse,setPaygResponse] =useState([])
  const [inputValue, setInputValue] = useState(true);
  
  
  const { dispatch } = useCartContext();
  const history = useNavigate();

  useEffect(() => {
    getBanner();
    getProductRate();
    getChitBenifitDaata();
    Promise.all([
      getSchemeType(),
    ]).then((result)=>{
      let shemeDt= result[0].filter((item) => item.type.toLowerCase() === DIGIGOLD);
      getShemedata(shemeDt[0].id)
    }).catch((error)=>{
      console.error(error)
    })
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getCustomerDetails();
    getPaymentModeList();
    //eslint-disable-next-line
  }, []);
  
  useEffect(() => {
    if(document.visibilityState === "visible" && getOrderKeyId()){
      checkPaygOrderStatus();
    }
  // eslint-disable-next-line
 },[documentVisibility])

 useEffect(()=>{
  handleAmountChange(Amount);
  //eslint-disable-next-line
 },[Amount])

 const getPaymentModeList = () => {
  const paymentModeRes = getAllPaymentMode();
  paymentModeRes.then((data) => {
    setPaymentModeList(data.response);
  });
};


  //chit no of types list --- 1
  const getSchemeType = async() => {
    try {
    let filter = {
      active: 0,
    };
    let shemeTypeData= await schemeType(filter);
    if(shemeTypeData.response.content.length > 0){
      let dt= shemeTypeData.response.content;
      let shemeDt= dt.filter((item) => item.type.toLowerCase() === DIGIGOLD);
      setScheme(shemeDt);
      return shemeDt;
    }

  } catch (error) {
      console.error(error);
  }
  };

  // chit metadata chittypeid base ---- 2
  const getShemedata = async (id) => {
    try {
    const shemeDatas = await schemeDetails(id);
    
    if (shemeDatas.response.content.length > 0) {
      let minValue = shemeDatas.response.content[0].minDueValue;
      let maxValue = shemeDatas.response.content[0].maxDueValue;
      setAmount(minValue);
      calculationWt(minValue);
      setMaxDuevalue(maxValue);
      setShemeMeta(shemeDatas.response.content[0]);
    }
  } catch (error) {
      console.error(error)
  }
  };

  // check if already avalible or not ---3
  const buyNow = async ()=>{
    if (getCustomerId() === undefined) {
      dispatch({ type: "MODAL", payload: "login" });
    } else{
      let filters={
              customerEntity: getCustomerId(),
              chitEnrollStatus: "Active"
            };
    await schemeStatus(filters).then((data)=>{
     const show = data.response.content.filter((item)=> item.metaChitName.toLowerCase() === DIGIGOLD);     
     setChitId(show[0].chitId)
     if(show.length > 0){
      // alert("hi");
      setshowModal(true);
     }else{
      history("/JoinScheme",{state:{shemeMeta}})
     }
    }).catch((error)=>console.error(error));
  };
};

  // radiobutton
  const onOptionChange = (e) => {
    setChangeRadioButton(e.target.value);
  };

  const getBanner = () => {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "productList") {
          setBanner(data.value);
        }
      });
  };

  // product rate
  const getProductRate = async () => {
    try {
      let fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
      let toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    const filterData = {
      branch: getBranchId(),
      createdAtFrom: filterFormatFromDate(fromDate),
        createdAtTo: filterFormatToDate(toDate)
    };
    const todayMetalRate = await PurityApi(filterData);
    if (todayMetalRate.errorCode === undefined) {
      let isGoldRateFound = false;
      todayMetalRate.response.forEach((item) => {
        if (
          item.metaProdTypeName &&
          item.metaProdTypeName.toLowerCase() === "gold" &&
          item.purity.includes("22") &&
          !isGoldRateFound
        ) {
          item.purity = "22K";
          setRecentGoldRate(item);
          isGoldRateFound = true;
        }
      });
    }
  } catch (error) {
      console.error(error);
  }
  };


  // const handleAmountChange = (text) => {
  //   // if(Number(text) > 0){
  //   let newAmt = Number(text);
  //     setInputValue(false);
  //   setAmount(newAmt);
  //   calculationWt(newAmt);
  // //   }
  // // else{
  //   // setInputValue(true);
  //   // setAmount('');
  //   // calculationWt('');
  //   // setWeight(weight);
  //   // }
  // };
  
  const handleAmountChange = (text) => {
    const newAmt = Number(text);
    if (!isNaN(newAmt) && newAmt >= 0) {
      setInputValue(false);
      setAmount(newAmt);
      calculationWt(newAmt);
    } else {
      setInputValue(true);
      setAmount(0); // Reset amount if invalid
      setWeight(0); // Reset weight if amount is invalid
    }
  };


  const calculationWt = (amt) => {
    const findWt = amt / recentGoldRate.onlineRate;
    if (findWt > 0) {
      const grms = numberCutOff(findWt, weightDecimalPlaces).toString();
      setWeight(parseFloat(grms));
    }
  };


  // const handleWeightChange = (weight) => {
  //   let weightValue = parseFloat(weight);
  //   const findWt = weightValue * recentGoldRate.onlineRate;
  //   let secWtValue = numberCutOff(findWt, weightDecimalPlaces).toString();
  //   setAmount(parseFloat(secWtValue));
  //   setWeight(secWtValue);
  // };
  const getWeight = (event) =>{
    setWeight(event)
   console.log("event",weight);
  };

  // const handleWeightChange = (weight) => {
  //   const weightValue = parseFloat(weight);
    
  //   // Check if weightValue is valid
  //   if (!isNaN(weightValue) && weightValue >= 0) {
  //     const findAmt = weightValue * recentGoldRate.onlineRate; // Calculate amount based on weight
  //     const formattedAmt = numberCutOff(findAmt, weightDecimalPlaces).toString();
      
  //     // Update both amount and weight state
  //     setAmount(parseFloat(formattedAmt));
  //     setWeight(weightValue);
  //   } else {
  //     // Reset amount if weight is invalid
  //     setAmount(0);
  //   }
  // };
  


  const handleRangeAmount = (value) => {
    let calAmount = Amount + value;
    if (value === HUNDRED) {
      const wt = parseFloat(calAmount / recentGoldRate.onlineRate);
      setAmount(calAmount);
      setWeight(numberCutOff(wt, weightDecimalPlaces));
    } else if (value === FIVEHUNDRED) {
      const wt = parseFloat(calAmount / recentGoldRate.onlineRate);
      setAmount(calAmount);
      setWeight(numberCutOff(wt, weightDecimalPlaces));
    } else if (value === THOUSAND) {
      const wt = parseFloat(calAmount / recentGoldRate.onlineRate);
      setAmount(calAmount);
      setWeight(numberCutOff(wt, weightDecimalPlaces));
    } else if (value === TW0THOUSAND) {
      const wt = parseFloat(calAmount / recentGoldRate.onlineRate);
      setAmount(calAmount);
      setWeight(numberCutOff(wt, weightDecimalPlaces));
    }
  };


  const handleRangeWeight = (value) => {
    let Wt = Number(weight);
    let calWeight = Wt + value;
    if (value === ZERO_POINT_FIVE) {
      const newAmount = calWeight * recentGoldRate.onlineRate;
      setAmount(newAmount.toFixed(2));
      setWeight(numberCutOff(calWeight, weightDecimalPlaces));
    } else if (value === ONE_GRAM) {
      const newAmount = calWeight * recentGoldRate.onlineRate;
      setAmount(newAmount.toFixed(2));
      setWeight(numberCutOff(calWeight, weightDecimalPlaces));
    } else if (value === TWO_GRAM) {
      const newAmount = calWeight * recentGoldRate.onlineRate;
      setAmount(newAmount.toFixed(2));
      setWeight(numberCutOff(calWeight, weightDecimalPlaces));
    }
  };


  const getChitBenifitDaata = async () => {
    try {
    let benefitValue = 0;
    let payableValue = 0;
    const chitTypeId = prpsData?.chitTypeId;
    const chitEnrollmentId = prpsData?.id;
    const chitAmount = 200;
    const getChitBenefitResData = await getChitBenefitValueData(
      chitTypeId,
      chitEnrollmentId,
      chitAmount
    );
    if (getChitBenefitResData.response) {
      benefitValue = getChitBenefitResData.response.benefitValue;
      payableValue = getChitBenefitResData.response.payableValue;
    }
    setBenefitValue(
      benefitValue && parseFloat(benefitValue) > 0.0
        ? parseFloat(benefitValue).toFixed(2)
        : "0.00"
    );
    setPayableValue(payableValue);
  } catch (error) {
      console.error(error);      
  }
  };

  // paymentgatway function start

  //get customer Details
  const getCustomerDetails = () => {
    const response =  getCustomer(getCustomerId());
    response.then((data) => {
      setDetails({
        name: data.response.name,
        mobile: data.response.mobile,
        email: data.response.email,
        address1:
          data.response.customerAddress != null
            ? data.response.customerAddress.address1
            : "",
        branchName: data.response.branchName != null ? data.response.branchName : "-",
        branchId : data.response.branchId,
        customerId : data.response.id,
        countryName : data.response.countryName !== undefined ? data.response.countryName : null,
        stateName : data.response.stateName !== undefined ? data.response.stateName : null,
        pincodeNumber : data.response.pincodeNumber !== undefined ? data.response.pincodeNumber : null,
        districtName : data.response.districtName !== undefined ? data.response.districtName : null
      });
    });
  };

  // ccavenue link
const submitCcavenue = () =>{
    setPayLoading(true);
  const requestData = {
    amount: Number(Amount),
    branchId: Details.branchId,
    branchName: Details.branchName,
    currencyCode: "INR",
    customerEmail: Details.email,
    customerId: Details.customerId,
    customerName: Details.name,
    customerPhone: Details.mobile,
    gatewayName: "CCAVENUE",
    orderId: chitId,
    paymentPurpose: "ECOMM_WEB_SALES",
    productDesc: chitId,
    usageFrom: "WEB",             
  };

  getCcavenuePaymentLinkData(requestData).then((data) =>{
    Promise.all([
      setTwalletInvsId(
      JSON.stringify({
        invoiceId : data.response.invoice_id,
    })
  ),
    data.response.tiny_url,
  ]).then((item) => {
      const tinyUrl = item[1];
      setPayLoading(true);
      if(tinyUrl){
        setTimeout(() => {
          setPayLoading(false);
          window.open(tinyUrl);
        }, 10000);
      } else {
        console.error("Invalid tiny URL:", tinyUrl);
        setPayLoading(false)
      }
    })
  }).catch(error => console.error(error))
};

const onCheckboxChange = (event) => {
  setAgreeTerms(event.target.checked);
};

const onRadioChange = (event) => {
  setSelectedPaymentMethod(event.target.value);
};

const validateForm = () => {
  return selectedPaymentMethod !== "" && agreeTerms;
};

const handleForms =(event)=>{
  event.preventDefault();
}

const submitPayg =() =>{
const paygRequestData = {
  acceptTerms: "Yes",
  acceptTermsDatetime: currentDateToUtcDate(currentRegister()),
  amount: Number(Amount),
  approvalCode: "",
  authCode: "",
  authKey: null,
  authToken: null,
  authorizedAmount: Number(Amount),
  branchId: branch.id,
  branchName: branch.branchName,
  cancelRedirectUrl: "",
  cardDetails: "[]",
  clientSource: "",
  currencyCode: "INR",
  customerEmail: Details.email,
  customerId: Details.customerId,
  customerIdPg: Details.customerId,
  customerName: Details.name,
  customerNotes: "Chit Details",
  customerPhone: Details.mobile,
  dataSource: "ECOMM_WEB_SALES",
  gatewayName: "PAYG",
  getwayName: "PAYG",
  hash: "",
  metalRate: NaN,
  mid: null,
  orderId: "",
  payId: "",
  paymentChannel: "PAYG",
  paymentProcessUrl: "",
  paymentPurpose: "ECOMM_WEB_SALES",
  paymentType: "ALL",
  productDesc: chitId,
  rawData: "{}",
  reasonCode: "",
  refTransactionId: "",
  responseCode: "-",
  responseDatetime: currentDateToUtcDate(currentRegister()),
  responseMessage: "",
  responseUrl: "",
  retryStatus: "",
  returnUrl: "https://prod-rasiinfotech.in/prodresponse.php?orderid=",
  salt: "",
  status: "Initiating",
  transactionData: {
    
  },
  transactionReferenceNo: "",
  txnId: "",
  txnType: "",
  uniqueRequestId: "",
  usageFrom: "WEB",
  userDefinedData: {
    UserDefined1: chitId,
    UserDefined10: Number(Amount),
    UserDefined11: Number(Amount),
    UserDefined2: Number(Amount),
    UserDefined3: 6,
    UserDefined4: "Rasi",
    UserDefined5: "30bcd214-4b92-4a74-84cf-af67ba4de32b",
    UserDefined6: Number(Amount),
    UserDefined7: NaN,
    UserDefined8: NaN,
    UserDefined9: 0
  },
  userName: Details.name
}
paygOrderStatus(JSON.stringify(paygRequestData)).then((data) => {
  if(data.responseCode === 201 ){
    setPaygResponse(data.response);
  }
  Promise.all([
    setOrderKeyId(
      JSON.stringify({
        orderId: data.response.orderId,
        statusId: data.response.id,
      })
    ),
  ]).then((item) => {
    setPayLoading(false);
    window.open(data.response.paymentProcessUrl);
    // window.location.href = data.response.paymentProcessUrl;
  }).catch(error => console.error(error));
});
};

const checkPaygOrderStatus = async () =>{
  let branchName = branch.branchName;
  let OrderId = JSON.parse(getOrderKeyId())?.orderId;
 const getPaymentStatus = await getPageOrderStatus(branchName,OrderId);
 try {
   if(getPaymentStatus.responseCode === 200){
    
    let payGStatusResData =getPaymentStatus.response;
     const payGStatusDetails = {
      responseCode: '',
      paymentStatus: 'Initiating',
      paymentResponseText: ''
    };
    if (payGStatusResData.OrderKeyId !== undefined) {
      payGStatusDetails.paymentResponseText = payGStatusResData.PaymentResponseText ? payGStatusResData.PaymentResponseText : '';
      if (payGStatusResData.PaymentResponseCode === 1) {
        payGStatusDetails.paymentStatus = 'Success';
        payGStatusDetails.responseCode = '1';
      } else if (payGStatusResData.PaymentResponseCode === 2) {
        payGStatusDetails.paymentStatus = 'Declined';
        payGStatusDetails.responseCode = '2';
      } else if (payGStatusResData.PaymentResponseCode === 4) {
        payGStatusDetails.paymentStatus = 'Pending';
        payGStatusDetails.responseCode = '4';
      }
      const onlinePaymentCreatedDate = moment(payGStatusResData.UpdatedDateTime, 'MM/DD/YYYY hh:mm:ss A').format('YYYY-MM-DD HH:mm:ss');
      const paymentDateWithTime = currentDateToUtcDate(onlinePaymentCreatedDate);
  
      const paymentDetailsObj = {
        orderId: payGStatusResData.OrderKeyId,
        amount: parseFloat(payGStatusResData.UserDefinedData.UserDefined2).toFixed(2),
        txnId: payGStatusResData.PaymentTransactionId ? payGStatusResData.PaymentTransactionId : '',
        responseCode: payGStatusDetails.responseCode,
        responseMessage: payGStatusDetails.paymentResponseText,
        status: payGStatusDetails.paymentStatus,
        // responseMessage: payGStatusDetails.paymentResponseText ==="Declined -" ? "Success" : "Declined",
        // status: payGStatusDetails.paymentStatus === "Declined" ?  "Success" : "Declined",
        responseDatetime: paymentDateWithTime,
        authorizedAmount: parseFloat(payGStatusResData.OrderAmount).toFixed(2),
        paymentModeName: payGStatusResData.PaymentMethod,
        id: payGStatusResData.UniqueRequestId,
      };
      updateOnlineAndSalesData(paymentDetailsObj,'PAYG');
    } 
   }
  }
   catch (error) {
     console.error(error);
   }
};


const updateOnlineAndSalesData = async(paymentDetailsObj, ecommPaymentGatewayType) =>{
  let filteredPaymodeData = [];
  let filterPaymodeName = '';

  if (ecommPaymentGatewayType === 'PAYG'){
    filterPaymodeName = 'payGShortCode';  
  }
  filteredPaymodeData = paymentModeList.filter(item =>  item[filterPaymodeName] !== null && item[filterPaymodeName]?.toLowerCase() === paymentDetailsObj.paymentModeName?.toLowerCase());
  let customerId= getCustomerId();
  let customerName = Details.name;
  const saleOnlinePaymentReqData = {
    payId: "-",
    amount: parseFloat(paymentDetailsObj.amount).toFixed(2),
    orderId: paymentDetailsObj.orderId,
    returnUrl: "",
    salt: "-",
    hash: "-",
    customerId,
    customerName,
    txnType: filteredPaymodeData.length > 0 ? filteredPaymodeData[0].name : (paymentDetailsObj.paymentModeName ? paymentDetailsObj.paymentModeName : null),
    currencyCode: 'INR',
    productDesc: chitId,  
    txnId: paymentDetailsObj.txnId ? paymentDetailsObj.txnId : '',
    responseCode: paymentDetailsObj.responseCode,
    responseMessage: paymentDetailsObj.responseMessage,
    authCode: "-",
    // status: paymentDetailsObj.status === "Declined" ?"Success" : "Declined" ,
    status: paymentDetailsObj.status,
    responseDatetime: paymentDetailsObj.responseDatetime,
    authToken: paygResponse.authToken, 
    uniqueRequestId : paygResponse.uniqueRequestId,
    // uniqueRequestId: "VPLK8EBW45", 
    // authToken: "45312d7c790c4fce9fc716c860e0674c", 
    paymentType: "-",
    userName: "-",
    responseUrl: "-",
    refTransactionId: "-",
    cancelRedirectUrl: "-",
    approvalCode: "-",
    cardDetails: "[]",
    reasonCode: "-",
    transactionReferenceNo: "-",
    authorizedAmount: paymentDetailsObj.authorizedAmount,
    acceptTerms: 'Yes',
    acceptTermsDatetime: null,
    authKey : paygResponse.authKey,
    // authKey: "b0a3ef7f97714cf591c826d38b68e4c1",
    mid: paygResponse.mid,
    usageFrom: "Web",
    customerEmail: "-",
    customerPhone: Details.mobile,
    paymentProcessUrl :paygResponse.paymentProcessUrl ? paygResponse.paymentProcessUrl : "-", 
    // paymentProcessUrl: `https://payg.in/payment/payment?orderid=${paymentDetailsObj.orderId}`,
    rawData: "[]",
    clientSource: "-",
    customerIdPg: customerId,
    active: 1,
    paymentPurpose: 'ECOMM_WEB_SALES',
    id:paygResponse.id,
    // id: "edbdfafb-ea0b-4516-bd9b-2673c896e42c",
    branchId: branch.id
  };
  try {
  await paygOrderStatusUpdate(saleOnlinePaymentReqData);
   } catch (error) {
    console.error(error);
   }
};

//eslint-disable-next-line
const getCustomerShemeDetails = async() =>{
  try {
   let  filter = {
    id:chitId.id,
    branchDetailsEntity : branch.id
    }
    const getCustomerData = await getCustomerSchemeById(filter);
    console.log("getCustomerData",getCustomerData);
    
  } catch (error) {
    console.error(error);
    throw error
  }
}

  // paymentgatway function end
 
  return (
    <>
    <Container>
      {banner && banner.length > 0 ? (
        <img src={banner} alt="Jewellery Product List " className="w-100" />
      ) : (
        <Skeleton tw="w-full" style={{ height: "400px" }} />
      )}
      <div className="digicard imgg">
        <h1 className="digititle">Buy Digital Gold</h1>
        <div className="row digirow">
          <div className="col">
            <h5>Powered By</h5>
            <img
              className="walletimg"
              src={TechWalletimg}
              alt="zinger-jewellery"
              width="210px"
              height="90px"
            />
            <div className="mt-2">
              <h4>Today Gold Rate :</h4>
              <h2>{`₹${recentGoldRate.onlineRate}/gm ${" "}`}</h2>
              <p className="purity">(22K)</p>
            </div>
          </div>
          <div className="col digitext">
            <h4>Invest Now</h4>
            <div className="radio-group">
              <input
                type="radio"
                id="buy-rupee"
                name="buy-option"
                value="Buyinrupee"
                checked={changeRadioButton === "Buyinrupee"}
                onChange={onOptionChange}
              />
              <span for="buy-rupee" className="mx-2">
                Buy in rupee
              </span>
              <input
                type="radio"
                id="buy-grms"
                name="buy-option"
                value="Buyingrms"
                checked={changeRadioButton === "Buyingrms"}
                onChange={onOptionChange}
              />
              <span for="buy-grms" className="mx-2">
                Buy in grms
              </span>
            </div>
            <form className="forms" onSubmit={handleForms}>
              {changeRadioButton === "Buyinrupee" ? (
                <div className="form-group">
                  <input
                    className="digiinput"
                    type="text"
                    name="name"
                    value={Amount}
                    onChange={(e) => handleAmountChange(e.target.value)}
                    placeholder="Enter gold amount"
                    />
                  <span className="highlight"></span>
                  {/* <span className="bar"></span> */}
                  <div className="bar"></div>
                  <span className="gramposition">= {weight}gm</span>
                </div>
              ) : (
                <div className="form-group">
                  {/* <input
                    className="digiinput"
                    type="text"
                    name="name"
                    value={weight}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setWeight(e.target.value)
                    }}
                    placeholder="Enter gold grams"
                  /> */}
                   <input
                    className="digiinput"
                    type="text"
                    name="name"
                    value={weight}
                    onChange={(e) => getWeight(e.target.value)}
                    placeholder="Enter gold grams"
                  />
                  <span className="highlight"></span>
                  {/* <span className="bar"></span> */}
                  <div className="bar"></div>
                  <span className="gramposition"> = ₹{Amount}</span>
                </div>
              )}
            </form>
            {changeRadioButton === "Buyinrupee" ? (
              <div className="amount-buttons">
                <button
                  className="amount-button"
                  onClick={() => handleRangeAmount(HUNDRED)}
                >
                  {PLUS_SYMBOL} ₹100
                </button>
                <button
                  className="amount-button"
                  onClick={() => handleRangeAmount(FIVEHUNDRED)}
                >
                  {PLUS_SYMBOL} ₹500
                </button>
                <button
                  className="amount-button"
                  onClick={() => handleRangeAmount(THOUSAND)}
                >
                  {PLUS_SYMBOL} ₹1,000
                </button>
                <button
                  className="amount-button"
                  onClick={() => handleRangeAmount(TW0THOUSAND)}
                >
                  {PLUS_SYMBOL} ₹2,000
                </button>
              </div>
            ) : (
              <div className="amount-buttons">
                <button
                  className="amount-button"
                  onClick={() => handleRangeWeight(ZERO_POINT_FIVE)}
                >
                  {PLUS_SYMBOL} 0.5gm
                </button>
                <button
                  className="amount-button"
                  onClick={() => handleRangeWeight(ONE_GRAM)}
                >
                  {PLUS_SYMBOL} 1gm
                </button>
                <button
                  className="amount-button"
                  onClick={() => handleRangeWeight(TWO_GRAM)}
                >
                  {PLUS_SYMBOL} 2gm
                </button>
              </div>
            )}
          </div>
          <div className="col  calc">
            <div className="pt-5 px-4">
              <div className="row">
                <p>
                  Amount: <span id="amount">{Amount}</span>
                </p>
              </div>
              <div className="row">
                {/* <p>Tax: <span id="tax">0</span></p> */}
              </div>
              <div className="horizantalcode"></div>
              <button className="buttonss" onClick={buyNow} disabled={inputValue}>
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="container"></div>
    </Container>
    {showModal ? (
        <>
          <motion.div
            initial={{ x: "700px", opacity: 0, scale: 0.5 }}
            animate={{ x: 0, opacity: 1, scale: 1 }}
            tw="justify-center  flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div tw="relative w-auto my-20 mx-auto w-1/4">
              {/*content*/}
              <div tw="relative border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div tw="flex items-start justify-between items-center p-2 border-b border-solid border-custom-100 rounded-t">
                  <h6 tw="text-sm m-0 uppercase tracking-wide">Choose Payment Method</h6>
                  <button
                    tw="p-1 ml-auto  border-0 text-gray-400 float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setshowModal(false)}
                  >
                    <i className="bi bi-x-circle"></i>
                  </button>
                </div>
                {/*body*/}
                <div tw="relative p-6 pb-3 flex-auto text-center">
                       <input
                          className="form-check-input"
                          type="radio"
                          value="CCAVENUE"
                          checked={selectedPaymentMethod === 'CCAVENUE'}
                          onChange={onRadioChange}

                         />
                     <label className="form-check-label">
                      CCAVENUE
                     </label>
                     <br/>
                    <input
                          className="form-check-input"
                          type="radio"
                          value="PAY_G"
                          checked={selectedPaymentMethod === 'PAY_G'}
                          onChange={onRadioChange}
                         />
                     <label className="form-check-label">
                      PAY_G
                     </label>
                     <br/>
                <input
                  className="form-check-input mx-sm-2 mx-sm-1"
                  type="checkbox"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  checked={agreeTerms}
                  onChange={onCheckboxChange}
                   />
                  <label
                    className="form-check-label text-xs"
                    htmlFor="flexRadioDefault1"
                  >
                    I Agree with the Terms & Conditions
                  </label>
                  {/* <p>Already Joined in this Scheme & Status is Pending...</p> */}
                  {/* <p tw="mb-1">Please Contact Customer Support</p> */}
                  {/* <strong>{BranchMobile}</strong> */}
                </div>
                <div tw="text-center">
              
                  <button
                    type="button"
                    className="btn btn-dark w-50 border-0 "
                    tw="bg-custom-100 mb-4"
                    onClick={selectedPaymentMethod === 'CCAVENUE'? submitCcavenue :submitPayg}
                    disabled ={validateForm() ||payLoading}
                  >
                        {payLoading ? (
                            <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            ></span>
                            <span className="mx-2">Loading . . .</span>
                          </>
                        ) : (
                          <>
                              <i
                              className="bi bi-credit-card-2-front"
                              tw="px-3 text-base"
                            ></i>
                           Proceed to Pay
                          </>
                        )}
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
          <div tw="opacity-25 fixed inset-0 z-40 bg-black "></div>
        </>
      ) : null}
    </>
  );
}

export default TechWallet;
